export default __webpack_public_path__ + "static/media/HYBRID-2.b437f35e.png";